const defaultClass = 'reveal'
const activeClass = 'reveal--active'

export default {
  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('readystatechange', () => {
        setTimeout(() => {
          this.revealItemsSetup()
        }, 10)
      })
    }
    else {
      setTimeout(() => {
        this.revealItemsSetup()
      }, 10)
    }
  },

  revealItemsSetup() {
    const items = Array.from(document.querySelectorAll(`.${defaultClass}:not(.${activeClass})`))

    const intObserver = new IntersectionObserver((entries) => {
      entries
        .filter(entry => entry.isIntersecting)
        .forEach(entry => {
          setTimeout(() => {
            entry.target.classList.add(activeClass)
          }, Math.random() * 100)
        })
    }, {
      threshold: 0.2
    })

    items.forEach(el => intObserver.observe(el))
  }
}
